export const castArray = <T>(value: T | T[]) => {
  return value ? (Array.isArray(value) ? value : [value]) : [];
};
